export enum GmbAttributesEnum {
    ACCEPTS_CHEQUE_APETIZ_MEAL_VOUCHER = 'accepts_cheque_apetiz_meal_voucher',
    ACCEPTS_CHEQUE_DEJEUNER_MEAL_VOUCHER = 'accepts_cheque_dejeuner_meal_voucher',
    ACCEPTS_MEAL_COUPONS = 'accepts_meal_coupons',
    ACCEPTS_RESERVATIONS = 'accepts_reservations',
    ACCEPTS_SODEXO_MEAL_VOUCHER = 'accepts_sodexo_meal_voucher',
    ACCEPTS_TICKET_RESTAURANT_MEAL_VOUCHER = 'accepts_ticket_restaurant_meal_voucher',
    ALLOWS_DOGS_INSIDE = 'allows_dogs_inside',
    ALLOWS_DOGS_OUTSIDE = 'allows_dogs_outside',
    HAS_ALL_YOU_CAN_EAT_ALWAYS = 'has_all_you_can_eat_always',
    HAS_ARCADE_GAMES = 'has_arcade_games',
    HAS_BAR_ONSITE = 'has_bar_onsite',
    HAS_BRAILLE_MENU = 'has_braille_menu',
    HAS_CABARET = 'has_cabaret',
    HAS_CATERING = 'has_catering',
    HAS_CHANGING_TABLES = 'has_changing_tables',
    HAS_CHILD_CARE = 'has_child_care',
    HAS_CHILDRENS_MENU = 'has_childrens_menu',
    HAS_COUNTER_SERVICE = 'has_counter_service',
    HAS_CURBSIDE_PICKUP = 'has_curbside_pickup',
    HAS_DELIVERY = 'has_delivery',
    HAS_DRIVE_THROUGH = 'has_drive_through',
    HAS_FIREPLACE = 'has_fireplace',
    HAS_HEARING_LOOP = 'has_hearing_loop',
    HAS_HIGH_CHAIRS = 'has_high_chairs',
    HAS_IN_STORE_SHOPPING = 'has_in_store_shopping',
    HAS_LIVE_MUSIC = 'has_live_music',
    HAS_NO_CONTACT_DELIVERY = 'has_no_contact_delivery',
    HAS_ONSITE_PARKING = 'has_onsite_parking',
    HAS_ONSITE_SERVICES = 'has_onsite_services',
    HAS_ORDER_AND_PAY_AHEAD = 'has_order_and_pay_ahead',
    HAS_PARKING_GARAGE_FREE = 'has_parking_garage_free',
    HAS_PARKING_GARAGE_PAID = 'has_parking_garage_paid',
    HAS_PARKING_LOT_FREE = 'has_parking_lot_free',
    HAS_PARKING_LOT_PAID = 'has_parking_lot_paid',
    HAS_PARKING_STREET_FREE = 'has_parking_street_free',
    HAS_PARKING_STREET_PAID = 'has_parking_street_paid',
    HAS_PARKING_VALET = 'has_parking_valet',
    HAS_PRIVATE_DINING_ROOM = 'has_private_dining_room',
    HAS_RESTROOM = 'has_restroom',
    HAS_RESTROOM_UNISEX = 'has_restroom_unisex',
    HAS_SALAD_BAR = 'has_salad_bar',
    HAS_SEATING = 'has_seating',
    HAS_SEATING_OUTDOORS = 'has_seating_outdoors',
    HAS_SEATING_ROOFTOP = 'has_seating_rooftop',
    HAS_TAKEOUT = 'has_takeout',
    HAS_TRIVIA_NIGHT = 'has_trivia_night',
    HAS_WHEELCHAIR_ACCESSIBLE_ENTRANCE = 'has_wheelchair_accessible_entrance',
    HAS_WHEELCHAIR_ACCESSIBLE_PARKING = 'has_wheelchair_accessible_parking',
    HAS_WHEELCHAIR_ACCESSIBLE_RESTROOM = 'has_wheelchair_accessible_restroom',
    HAS_WHEELCHAIR_ACCESSIBLE_SEATING = 'has_wheelchair_accessible_seating',
    IS_OWNED_BY_WOMEN = 'is_owned_by_women',
    IS_TRANSGENDER_SAFESPACE = 'is_transgender_safespace',
    NEEDS_VOLUNTEERS_DURING_CRISIS = 'needs_volunteers_during_crisis',
    OFFERS_EMPLOYMENT_DURING_CRISIS = 'offers_employment_during_crisis',
    PAY_CHECK = 'pay_check',
    PAY_CREDIT_CARD = 'pay_credit_card',
    PAY_CREDIT_CARD_TYPES_ACCEPTED = 'pay_credit_card_types_accepted',
    PAY_DEBIT_CARD = 'pay_debit_card',
    PAY_MOBILE_NFC = 'pay_mobile_nfc',
    REQUIRES_CASH_ONLY = 'requires_cash_only',
    REQUIRES_MEMBERSHIP = 'requires_membership',
    REQUIRES_RESERVATIONS = 'requires_reservations',
    SERVES_ALCOHOL = 'serves_alcohol',
    SERVES_BEER = 'serves_beer',
    SERVES_BREAKFAST = 'serves_breakfast',
    SERVES_BRUNCH = 'serves_brunch',
    SERVES_COCKTAILS = 'serves_cocktails',
    SERVES_COFFEE = 'serves_coffee',
    SERVES_DESSERT = 'serves_dessert',
    SERVES_DINE_IN = 'serves_dine_in',
    SERVES_DINNER = 'serves_dinner',
    SERVES_HALAL_FOOD = 'serves_halal_food',
    SERVES_HAPPY_HOUR_DRINKS = 'serves_happy_hour_drinks',
    SERVES_HAPPY_HOUR_FOOD = 'serves_happy_hour_food',
    SERVES_LATE_NIGHT_FOOD = 'serves_late_night_food',
    SERVES_LIQUOR = 'serves_liquor',
    SERVES_LUNCH = 'serves_lunch',
    SERVES_ORGANIC = 'serves_organic',
    SERVES_SMALL_PLATES = 'serves_small_plates',
    SERVES_VEGAN = 'serves_vegan',
    SERVES_VEGETARIAN = 'serves_vegetarian',
    SERVES_WINE = 'serves_wine',
    SUITABLE_FOR_WATCHING_SPORTS = 'suitable_for_watching_sports',
    URL_FACEBOOK = 'url_facebook',
    URL_INSTAGRAM = 'url_instagram',
    URL_LINKEDIN = 'url_linkedin',
    URL_MENU = 'url_menu',
    URL_ORDER_AHEAD = 'url_order_ahead',
    URL_PINTEREST = 'url_pinterest',
    URL_RESERVATIONS = 'url_reservations',
    URL_TIKTOK = 'url_tiktok',
    URL_TWITTER = 'url_twitter',
    URL_YOUTUBE = 'url_youtube',
    URL_WHATSAPP = 'url_whatsapp',
    URL_TEXT_MESSAGING = 'url_text_messaging',
    WELCOMES_CHILDREN = 'welcomes_children',
    WELCOMES_DOGS = 'welcomes_dogs',
    WELCOMES_FAMILIES = 'welcomes_families',
    WELCOMES_LGBTQ = 'welcomes_lgbtq',
    WI_FI = 'wi_fi',
}
